import { Session } from "/imports/client/client-session";
import { toast } from "react-toastify";

import { generatePath } from "react-router";
import {
  getSessionToken,
  getSessionUser,
  getSessionUserId
} from "/imports/api/accounts/client/user-session";
import { AppRoute } from "./appRoutes";

import Debug from "debug";
const debug = Debug("routes:helper");

const routesMap: Partial<Record<AppRoute, string>> = {};
let currentRoute = null;

// eslint-disable-next-line consistent-return
export const mustBeLoggedIn = function mustBeLoggedIn(request, redirect) {
  const { path } = request;

  // TODO:check token expiracy
  const isLoggedIn = !!getSessionToken();
  const user = getSessionUser();
  const isUnverified = user && !user.emailVerified;

  // debug("login status %o", { isLoggedIn, isUnverified });

  // TODO [$6130a08837762e00094fd3db]:
  const isLoginPage = false;

  if (!isLoggedIn || isUnverified) {
    if (!isLoginPage) {
      if (isUnverified) {
        debug("loginRedirect: redirect to signUp");
        toast.error(
          "Not able to redirect to Dashboard, user verification is not yet finished!"
        );

        return redirect("signUp");
      }

      Session.set("loginRedirect", path);
      debug("loginRedirect: redirect to signin %o", request);

      return redirect("signIn");
    }
  }

  return true;
};

export const mustBeAdmin = function mustBeAdmin(request, redirect) {
  const userId = getSessionUserId();
  const isLoggedIn = !!userId;

  // TODO:use api
  // const isAdmin = Roles.userIsInRole(userId, ["admin"], Roles.GLOBAL_GROUP);
  const isAdmin = false;
  if (!(isLoggedIn && isAdmin)) {
    debug("mustBeAdmin, redirect to dashboard!");

    redirect("dashboard");
  }
};

export const generateRoutePath = (name: AppRoute, params: any, query: object = {}) => {
  const pattern = routesMap[name] ?? "/";
  const path = generatePath(pattern, params);
  const queryParams = new URLSearchParams("");
  Object.entries(query).map(([key, val]: [string, string]) => {
    if (!key) {
      return;
    }
    if (!val) {
      return;
    }
    queryParams.set(key, val);
  });

  const queryString = queryParams.toString();

  const fullUrl = `${path}${queryString ? `?${queryString}` : ""}`;

  return fullUrl;
};

export const registerPath = (name: AppRoute, path: string) => {
  if (!name || !path) {
    return;
  }
  routesMap[name] = path;
};

export const setCurrentRoute = (route) => {
  currentRoute = route;
};

export const getCurrentRoute = () => {
  if (!currentRoute) {
    return null;
  }
  const path = routesMap[currentRoute];

  return { name: currentRoute, path };
};
